// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme fallbacks */
/* Solid gold accents (no gradients) */
/* ---------- Layout ---------- */
.rdice {
  font-family: "Almendra", serif;
  width: 100%;
  min-height: 40dvh; /* center vertically even on mobile address bars */
  display: grid;
  place-items: center; /* centers the card horizontally + vertically */
  padding-inline: 1rem; /* safe breathing room on the sides */
  box-sizing: border-box;
}

.rdice__card {
  width: min(760px, 100%); /* never exceed container width */
  margin-inline: auto; /* horizontal centering */
  box-sizing: border-box;
  background: #fff;
  border: 2px solid #d4af37;
  border-radius: 11px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
  padding: 1rem 1.1rem 1.1rem;
  text-align: center;
}

/* ---------- Title ---------- */
.rdice__title {
  margin: 0 0 0.4rem 0;
  font-weight: 700;
  color: #0b0b0c;
  font-size: clamp(1.2rem, 3.6vw, 1.6rem);
  letter-spacing: 0.2px;
}

/* ---------- Stage (dice + button + confetti) ---------- */
.rdice__stage {
  position: relative;
  padding: 0.2rem 0 0.6rem;
}

.rdice__confetti {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

/* Dice placement */
.rdice__dice {
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 0.4rem 0 0.6rem;
}

/* ---------- Die ---------- */
.die {
  --size: clamp(64px, 16vw, 84px);
  width: var(--size);
  height: var(--size);
  border-radius: 14px;
  background: #fff;
  border: 2px solid #d4af37;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.06);
  display: grid;
  place-items: center;
  transition: transform 0.15s ease;
}
.die.is-rolling {
  animation: rdice-shake 0.3s ease-in-out infinite;
}

.die__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  width: 70%;
  height: 70%;
}

.pip {
  width: 12px;
  height: 12px;
  background: #d4af37;
  border-radius: 999px;
  justify-self: center;
  align-self: center;
}

@keyframes rdice-shake {
  0% {
    transform: rotate(0deg) translate(0, 0);
  }
  25% {
    transform: rotate(-8deg) translate(-1px, 1px);
  }
  50% {
    transform: rotate(0deg) translate(0, 0);
  }
  75% {
    transform: rotate(8deg) translate(1px, -1px);
  }
  100% {
    transform: rotate(0deg) translate(0, 0);
  }
}
/* ---------- Controls ---------- */
.rdice__controls {
  display: grid;
  justify-content: center;
}

.rdice__controls .ui-btn {
  height: 2.6rem;
  padding: 0 1rem;
  font-size: 0.95rem;
}

/* ---------- Message + CTA ---------- */
.rdice__message {
  margin: 0.2rem 0 0.4rem;
  color: #0b0b0c;
  font-size: 1rem;
  letter-spacing: 0.2px;
  min-height: 1.4em; /* keeps layout stable before reveal */
}
.rdice__message.is-revealed {
  /* If you want a romantic look, uncomment:
  font-family: 'Great Vibes', cursive;
  font-size: clamp(1.4rem, 4.8vw, 2rem);
  line-height: 1.1;
  */
}

.rdice__cta {
  display: grid;
  justify-items: center;
}

.rdice__cta .ui-btn {
  height: 2.6rem;
  padding: 0 1rem;
  font-size: 0.95rem;
}

/* ---------- Small screens ---------- */
@media (max-width: 520px) {
  .rdice__dice {
    gap: 0.8rem;
  }
  .pip {
    width: 10px;
    height: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/RsvpDiceComponent/RsvpDiceComponent.scss"],"names":[],"mappings":"AAEA,oBAAA;AAKA,sCAAA;AAKA,iCAAA;AACA;EACE,8BAAA;EACA,WAAA;EACA,iBAAA,EAAA,kDAAA;EACA,aAAA;EACA,mBAAA,EAAA,+CAAA;EACA,oBAAA,EAAA,qCAAA;EACA,sBAAA;AATF;;AAYA;EACE,uBAAA,EAAA,iCAAA;EACA,mBAAA,EAAA,yBAAA;EACA,sBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,mBApBO;EAqBP,2CAAA;EACA,2BAAA;EACA,kBAAA;AAVF;;AAaA,gCAAA;AACA;EACE,oBAAA;EACA,gBAAA;EACA,cApCQ;EAqCR,uCAAA;EACA,qBAAA;AAVF;;AAaA,2DAAA;AACA;EACE,kBAAA;EACA,wBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAVF;;AAaA,mBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AAVF;;AAaA,8BAAA;AACA;EACE,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AAVF;AAYE;EACE,gDAAA;AAVJ;;AAcA;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,mBA1FO;EA2FP,oBAAA;EACA,oBAAA;EACA,kBAAA;AAXF;;AAcA;EACE;IAAO,uCAAA;EAVP;EAWA;IAAO,6CAAA;EARP;EASA;IAAO,uCAAA;EANP;EAOA;IAAO,4CAAA;EAJP;EAKA;IAAO,uCAAA;EAFP;AACF;AAIA,mCAAA;AACA;EACE,aAAA;EACA,uBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAFF;;AAKA,wCAAA;AACA;EACE,uBAAA;EACA,cA3HQ;EA4HR,eAAA;EACA,qBAAA;EACA,iBAAA,EAAA,sCAAA;AAFF;AAIE;EACE;;;;GAAA;AAEJ;;AAMA;EACE,aAAA;EACA,qBAAA;AAHF;;AAMA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAHF;;AAMA,wCAAA;AACA;EACE;IAAe,WAAA;EAFf;EAGA;IAAO,WAAA;IAAa,YAAA;EACpB;AACF","sourcesContent":["@use \"../styles/tokens\" as *;\r\n\r\n/* Theme fallbacks */\r\n$primary: if(global-variable-exists(color-primary), $color-primary, #7c3aed);\r\n$text:    if(global-variable-exists(color-text),   $color-text,   #0b0b0c);\r\n$muted:   if(global-variable-exists(color-muted),  $color-muted,  #6b7280);\r\n\r\n/* Solid gold accents (no gradients) */\r\n$gold-1: #d4af37;\r\n\r\n$radius: if(global-variable-exists(btn-radius), $btn-radius, 16px);\r\n\r\n/* ---------- Layout ---------- */\r\n.rdice {\r\n  font-family: 'Almendra', serif;\r\n  width: 100%;\r\n  min-height: 40dvh;         /* center vertically even on mobile address bars */\r\n  display: grid;\r\n  place-items: center;        /* centers the card horizontally + vertically */\r\n  padding-inline: 1rem;       /* safe breathing room on the sides */\r\n  box-sizing: border-box;\r\n}\r\n\r\n.rdice__card {\r\n  width: min(760px, 100%);    /* never exceed container width */\r\n  margin-inline: auto;        /* horizontal centering */\r\n  box-sizing: border-box;\r\n\r\n  background: #fff;\r\n  border: 2px solid $gold-1;\r\n  border-radius: $radius;\r\n  box-shadow: 0 10px 26px rgba(0,0,0,.08);\r\n  padding: 1rem 1.1rem 1.1rem;\r\n  text-align: center;\r\n}\r\n\r\n/* ---------- Title ---------- */\r\n.rdice__title {\r\n  margin: 0 0 .4rem 0;\r\n  font-weight: 700;\r\n  color: $text;\r\n  font-size: clamp(1.2rem, 3.6vw, 1.6rem);\r\n  letter-spacing: .2px;\r\n}\r\n\r\n/* ---------- Stage (dice + button + confetti) ---------- */\r\n.rdice__stage {\r\n  position: relative;\r\n  padding: .2rem 0 .6rem;\r\n}\r\n\r\n.rdice__confetti {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Dice placement */\r\n.rdice__dice {\r\n  display: grid;\r\n  grid-auto-flow: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin: .4rem 0 .6rem;\r\n}\r\n\r\n/* ---------- Die ---------- */\r\n.die {\r\n  --size: clamp(64px, 16vw, 84px);\r\n  width: var(--size);\r\n  height: var(--size);\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  border: 2px solid $gold-1;\r\n  box-shadow: 0 6px 14px rgba(0,0,0,.06);\r\n  display: grid;\r\n  place-items: center;\r\n  transition: transform .15s ease;\r\n\r\n  &.is-rolling {\r\n    animation: rdice-shake .3s ease-in-out infinite;\r\n  }\r\n}\r\n\r\n.die__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  grid-template-rows:    repeat(3, 1fr);\r\n  width: 70%;\r\n  height: 70%;\r\n}\r\n\r\n.pip {\r\n  width: 12px;\r\n  height: 12px;\r\n  background: $gold-1;\r\n  border-radius: 999px;\r\n  justify-self: center;\r\n  align-self: center;\r\n}\r\n\r\n@keyframes rdice-shake {\r\n  0%   { transform: rotate(0deg) translate(0,0); }\r\n  25%  { transform: rotate(-8deg) translate(-1px, 1px); }\r\n  50%  { transform: rotate(0deg) translate(0,0); }\r\n  75%  { transform: rotate(8deg) translate(1px, -1px); }\r\n  100% { transform: rotate(0deg) translate(0,0); }\r\n}\r\n\r\n/* ---------- Controls ---------- */\r\n.rdice__controls {\r\n  display: grid;\r\n  justify-content: center;\r\n}\r\n\r\n.rdice__controls .ui-btn {\r\n  height: 2.6rem;\r\n  padding: 0 1rem;\r\n  font-size: .95rem;\r\n}\r\n\r\n/* ---------- Message + CTA ---------- */\r\n.rdice__message {\r\n  margin: .2rem 0 .4rem;\r\n  color: $text;\r\n  font-size: 1rem;\r\n  letter-spacing: .2px;\r\n  min-height: 1.4em; /* keeps layout stable before reveal */\r\n\r\n  &.is-revealed {\r\n    /* If you want a romantic look, uncomment:\r\n    font-family: 'Great Vibes', cursive;\r\n    font-size: clamp(1.4rem, 4.8vw, 2rem);\r\n    line-height: 1.1;\r\n    */\r\n  }\r\n}\r\n\r\n.rdice__cta {\r\n  display: grid;\r\n  justify-items: center;\r\n}\r\n\r\n.rdice__cta .ui-btn {\r\n  height: 2.6rem;\r\n  padding: 0 1rem;\r\n  font-size: .95rem;\r\n}\r\n\r\n/* ---------- Small screens ---------- */\r\n@media (max-width: 520px) {\r\n  .rdice__dice { gap: .8rem; }\r\n  .pip { width: 10px; height: 10px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
